import React from "react";
import PropTypes from 'prop-types';
import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const AddNewItemButton = ({createNewItem, index, path, title}) => {
    return (
        <div style={{textAlign: 'center'}}>
            <Tooltip title={title ? title : 'New schema item'}>
                <IconButton style={{padding: 5}} size={"small"} onClick={() => createNewItem(path, index)}>
                    <Icon fontSize={"small"}>
                        add
                    </Icon>
                </IconButton>
            </Tooltip>
        </div>
    )
};

export default AddNewItemButton

AddNewItemButton.propTypes = {
    createNewItem: PropTypes.func,
    index: PropTypes.string,
    path: PropTypes.string,
    title: PropTypes.string
};